<div mat-dialog-title>
  <span>{{ "DIALOG_GENERATE_EVENT" | translate }}</span>
  <button mat-icon-button
    mat-dialog-close>
    <fa-icon icon="times"></fa-icon>
  </button>
</div>
<form [formGroup]="eventForm"
  (ngSubmit)="generateEvent()">
  <div class="custom-scrollbar"
    mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROVIDER' | translate }}</mat-label>
      <mat-select formControlName="supplier">
        <mat-option>
          <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
            [formControl]="searchForm.controls.supplier"
            [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option>
          <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
        </mat-option>
        @for (signalSource of SignalSource
          | keyvalue
          | listFilter:'value':searchForm.value.supplier:true:true
          | sort:false:'value'; track signalSource) {
          <mat-option
            [value]="SignalSource[signalSource.key]">
            {{ SignalSource[signalSource.key] }}
          </mat-option>
        }
      </mat-select>
      @if (eventForm.controls.supplier.errors?.required) {
        <mat-error>
          <fa-icon icon="circle-exclamation"></fa-icon>
          {{ "REQUIRED_SELECTION" | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'ASSET' | translate }}</mat-label>
      <mat-select formControlName="asset">
        <mat-select-trigger>
          <!-- Display the name of the selected asset -->
          {{ assets$ | async | listFilter:'id':eventForm.value.asset | extractPropertyPipe:'name' }}
        </mat-select-trigger>
        <mat-option>
          <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
            [formControl]="searchForm.controls.asset"
            [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option>
          <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
        </mat-option>
        @for (asset of assets$
          | async
          | listFilter:'name':searchForm.value.asset:true:true
          | sort:false:'name'
          | slice:0:200; track trackById(asset)) {
          <mat-option
            [value]="asset.id">
            <span>
              {{ asset.name }}<br>
              <small>{{ asset.family.parent_family.name }} / {{ asset.family?.name }}</small>
            </span>
          </mat-option>
        }
      </mat-select>
      <mat-hint>
        @if ((loadings.assets$ | async) === true) {
          <mat-progress-spinner mode="indeterminate"
            diameter="12"
          strokeWidth="2"></mat-progress-spinner>
          {{ "LOADING_DATA" | translate }}
        } @else {
          {{ "LIST_LIMITED_QTY" | translate:{number:'200'} }}
        }
      </mat-hint>
      @if ((loadings.assets$ | async) === false && eventForm.controls.asset.errors?.required) {
        <mat-error>
          <fa-icon icon="circle-exclamation"></fa-icon>
          {{ "REQUIRED_SELECTION" | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'TYPE' | translate }}</mat-label>
      <mat-select formControlName="type">
        <mat-option>
          <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
            [formControl]="searchForm.controls.type"
            [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option>
          <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
        </mat-option>
        @for (eventType of EventType
          | keyvalue
          | listFilter:'value':searchForm.value.type:true:true
          | sort:false:'value'; track eventType) {
          <mat-option
            [value]="eventType.key">
            {{ EventType[eventType.key] }}
          </mat-option>
        }
      </mat-select>
      @if (eventForm.controls.type.errors?.required) {
        <mat-error>
          <fa-icon icon="circle-exclamation"></fa-icon>
          {{ "REQUIRED_SELECTION" | translate }}
        </mat-error>
      }
    </mat-form-field>

    @if (eventForm.value.supplier === SignalSource.aswarm) {
      <mat-form-field
        appearance="outline">
        <mat-label>{{ 'STATUS' | translate }}</mat-label>
        <mat-select formControlName="status">
          <mat-option>
            <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
              [formControl]="searchForm.controls.status"
              [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option>
            <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
          </mat-option>
          @for (status of Status
            | keyvalue
            | listFilter:'value':searchForm.value.type:true:true
            | sort:false:'value'; track status) {
            <mat-option
              [value]="status.key">
              {{ status.value | translate }}
            </mat-option>
          }
        </mat-select>
        @if (eventForm.controls.status.errors?.required) {
          <mat-error>
            <fa-icon icon="circle-exclamation"></fa-icon>
            {{ "REQUIRED_SELECTION" | translate }}
          </mat-error>
        }
      </mat-form-field>
    }

    <!-- Depending on the select event type -->
    @switch (eventForm.value.type) {
      @case (EventType.data) {
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DATA' | translate }}</mat-label>
          <textarea matInput
            formControlName="data"
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"></textarea>
          @if (eventForm.controls.data.errors?.required) {
            <mat-error>
              <fa-icon icon="circle-exclamation"></fa-icon>
              {{ "REQUIRED_INPUT" | translate }}
            </mat-error>
          }
        </mat-form-field>
      }
      @case (EventType.location) {
        <mat-form-field appearance="outline">
          <mat-label>{{ 'LATITUDE' | translate }}</mat-label>
          <input matInput
            formControlName="latitude"
            type="number">
            <mat-icon matSuffix>height</mat-icon>
            @if (eventForm.controls.latitude.errors?.min || eventForm.controls.latitude.errors?.max) {
              <mat-error>
                <fa-icon icon="circle-exclamation"></fa-icon>
                {{ 'ERROR_RANGE_VALUE' | translate:{min: '-90', max: '90'} }}
              </mat-error>
            }
            @if (eventForm.controls.latitude.errors?.required) {
              <mat-error>
                <fa-icon icon="circle-exclamation"></fa-icon>
                {{ "REQUIRED_INPUT" | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LONGITUDE' | translate }}</mat-label>
            <input matInput
              formControlName="longitude"
              type="number">
              <mat-icon matSuffix>360</mat-icon>
              @if (eventForm.controls.longitude.errors?.min || eventForm.controls.longitude.errors?.max) {
                <mat-error>
                  <fa-icon icon="circle-exclamation"></fa-icon>
                  {{ 'ERROR_RANGE_VALUE' | translate:{min: '-180', max: '180'} }}
                </mat-error>
              }
              @if (eventForm.controls.longitude.errors?.required) {
                <mat-error>
                  <fa-icon icon="circle-exclamation"></fa-icon>
                  {{ "REQUIRED_INPUT" | translate }}
                </mat-error>
              }
            </mat-form-field>
          }
          @case (EventType.state) {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'STATE' | translate }}</mat-label>
              <mat-select formControlName="state">
                <mat-option>
                  <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
                    [formControl]="searchForm.controls.state"
                    [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option>
                  <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
                </mat-option>
                @for (state of State
                  | keyvalue
                  | listFilter:'value':searchForm.value.state:true:true
                  | sort:false:'value'; track state) {
                  <mat-option
                    [value]="State[state.key]">
                    {{ State[state.key] | translate }}
                  </mat-option>
                }
              </mat-select>
              @if (eventForm.controls.state.errors?.required) {
                <mat-error>
                  <fa-icon icon="circle-exclamation"></fa-icon>
                  {{ "REQUIRED_SELECTION" | translate }}
                </mat-error>
              }
            </mat-form-field>
          }
          @case (EventType.zone) {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'ZONE' | translate }}</mat-label>
              <mat-select formControlName="zone">
                <mat-option>
                  <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
                    [formControl]="searchForm.controls.zone"
                    [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option>
                  <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
                </mat-option>
                @for (zone of zones$
                  | async
                  | listFilter:'name':searchForm.value.zone:true:true
                  | sort:false:'name'; track trackById(zone)) {
                  <mat-option
                    [value]="zone.id">
                    {{ zone.name }}
                  </mat-option>
                }
              </mat-select>
              @if ((loadings.zones$ | async) === true) {
                <mat-hint>
                  <mat-progress-spinner mode="indeterminate"
                    diameter="12"
                  strokeWidth="2"></mat-progress-spinner>
                  {{ "LOADING_DATA" | translate }}
                </mat-hint>
              }
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'STATE' | translate }}</mat-label>
              <mat-select formControlName="state">
                <mat-option>
                  <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
                    [formControl]="searchForm.controls.state"
                    [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option>
                  <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
                </mat-option>
                @for (state of State
                  | keyvalue
                  | listFilter:'value':searchForm.value.state:true:true
                  | sort:false:'value'; track state) {
                  <mat-option
                    [value]="State[state.key]">
                    {{ State[state.key] | translate }}
                  </mat-option>
                }
              </mat-select>
              @if ((loadings.zones$ | async) === false && eventForm.controls.state.errors?.required) {
                <mat-error>
                  <fa-icon icon="circle-exclamation"></fa-icon>
                  {{ "REQUIRED_SELECTION" | translate }}
                </mat-error>
              }
              @if (eventForm.controls.zone.errors?.required) {
                <mat-error>
                  <fa-icon icon="circle-exclamation"></fa-icon>
                  {{ "REQUIRED_SELECTION" | translate }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'ACCURACY' | translate }}</mat-label>
              <input matInput
                formControlName="accuracy"
                type="number">
                @if (eventForm.controls.accuracy.errors?.min) {
                  <mat-error>
                    <fa-icon icon="circle-exclamation"></fa-icon>
                    {{ 'ERROR_MIN_VALUE' | translate:{min: '0'} }}
                  </mat-error>
                }
                @if (eventForm.controls.accuracy.errors?.required) {
                  <mat-error>
                    <fa-icon icon="circle-exclamation"></fa-icon>
                    {{ "REQUIRED_INPUT" | translate }}
                  </mat-error>
                }
              </mat-form-field>
            }
          }
        </div>
        <div mat-dialog-actions>
          <button type="button"
            mat-stroked-button
            mat-dialog-close
            color="primary">
            {{ "CANCEL" | translate }}
          </button>
          <button type="submit"
            mat-flat-button
            color="primary"
            [disabled]="eventForm.invalid || loadings.submit">
            {{ "Generate" }}
            @if (loadings.submit) {
              <mat-progress-spinner
                mode="indeterminate"
                diameter="16"
                strokeWidth="2">
              </mat-progress-spinner>
            }
          </button>
        </div>
      </form>
